
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.369.002c2.854.059 5.42 1.594 6.865 4.108a8.414 8.414 0 01.108 8.256L9.438 23.259l-.008.014A1.42 1.42 0 018.186 24a1.42 1.42 0 01-1.245-.727l-.008-.014-5.904-10.893a8.414 8.414 0 01.108-8.256C2.582 1.596 5.148.06 8.002.002c.122-.003.245-.003.367 0zM4.837 7.5c0 1.861 1.502 3.375 3.348 3.375 1.846 0 3.348-1.514 3.348-3.375s-1.502-3.375-3.348-3.375c-1.846 0-3.348 1.514-3.348 3.375z","fill":"#5673A8"}})])
          )
        }
      }
    